import {
  USER_PERMISSIONS_LIST,
  USER_PERMISSIONS_LIST_SUCCESS,
  USER_PERMISSIONS_LIST_ERROR,
  USER_PERMISSIONS_NEW,
  USER_PERMISSIONS_NEW_SUCCESS,
  USER_PERMISSIONS_NEW_ERROR,
  USER_PERMISSIONS_EDIT,
  USER_PERMISSIONS_DELETE,
  USER_PERMISSIONS_DELETE_SUCCESS,
  USER_PERMISSIONS_DELETE_ERROR,
  USER_PERMISSIONS_TYPES_LIST,
  USER_PERMISSIONS_TYPES_LIST_SUCCESS,
  USER_PERMISSIONS_TYPES_LIST_ERROR,
} from "./actionTypes"


export const userPermissionsList = data => ({
  type: USER_PERMISSIONS_LIST,
  payload: data
});

export const userPermissionsListSuccess = data => ({
  type: USER_PERMISSIONS_LIST_SUCCESS,
  payload: {data}
});

export const userPermissionsListError = error => ({
  type: USER_PERMISSIONS_LIST_ERROR,
  payload: error
});

export const userPermissionsNew = data => ({
  type: USER_PERMISSIONS_NEW,
  payload: data
});

export const userPermissionsNewSuccess = data => ({
  type: USER_PERMISSIONS_NEW_SUCCESS,
  payload: {data}
});

export const userPermissionsNewError = error => ({
  type: USER_PERMISSIONS_NEW_ERROR,
  payload: error
});

export const userPermissionsEdit = data => ({
  type: USER_PERMISSIONS_EDIT,
  payload: data
});

export const userPermissionsDelete = data => ({
  type: USER_PERMISSIONS_DELETE,
  payload: data
});

export const userPermissionsDeleteSuccess = data => ({
  type: USER_PERMISSIONS_DELETE_SUCCESS,
  payload: {data}
});

export const userPermissionsDeleteError = error => ({
  type: USER_PERMISSIONS_DELETE_ERROR,
  payload: error
});

export const userPermissionsTypesList = data => ({
  type: USER_PERMISSIONS_TYPES_LIST,
  payload: data
});

export const userPermissionsTypesListSuccess = data => ({
  type: USER_PERMISSIONS_TYPES_LIST_SUCCESS,
  payload: {data}
});

export const userPermissionsTypesListError = error => ({
  type: USER_PERMISSIONS_TYPES_LIST_ERROR,
  payload: error
});